import React, { useEffect } from 'react'
import styled from 'styled-components'
import { findRenderedComponentWithType } from 'react-dom/test-utils'
import { selectUserName, selectUserPhoto, selectUserEmail, setUserLogin, setSignOut } from '../features/user/userSlice'
import { useSelector, useDispatch } from 'react-redux'
import { auth, provider } from '../firebase'
import { useNavigate } from "react-router-dom"
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut, } from "firebase/auth";

import { onAuthStateChanged } from "firebase/auth";
export default function Header() {

    const userName = useSelector(selectUserName)
    const userPhoto = useSelector(selectUserPhoto)
    const history = useNavigate()
    const dispatch = useDispatch()


    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User

                const uid = user.uid;
                dispatch(setUserLogin({
                    name: user.displayName,
                    email: user.email,
                    phone: user.photoURL

                }))
                history("/")
                // ...
            } else {
                history("/login")
            }
        });

    },[])



    const signIn = () => {
        signInWithPopup(auth, provider)
            .then((result) => {
                // This gives you a Google Access Token. You can use it to access the Google API.
                const credential = GoogleAuthProvider.credentialFromResult(result);
                const token = credential.accessToken;

                const user = result.user;
               
                dispatch(setUserLogin({
                    name: user.displayName,
                    email: user.email,
                    phone: user.photoURL

                }))
                history("/")
            }).catch((error) => {
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                // The email of the user's account used.
                const email = error.customData.email;
                // The AuthCredential type that was used.
                const credential = GoogleAuthProvider.credentialFromError(error);
                // ...
            });
    }

    const signOut1 = () => {
        signOut(auth).then(() => {
            // Sign-out successful.
            dispatch(setSignOut())
            history("/login")
        }).catch((error) => {
            // An error happened.
        });
    }

    return (
        <Nav>
            <Logo src="/images/logo.svg" />

            {!userName ? (
                <CointainLogin>
                    <Login onClick={signIn}>Login</Login>
                </CointainLogin>
            ) :

                <>
                    <NavMenu>
                        <a href=''>
                            <img src='/images/home-icon.svg' />
                            <span>HOME</span>
                        </a>
                        <a href=''>
                            <img src='/images/search-icon.svg' />
                            <span>SEARCH</span>
                        </a>
                        <a href=''>
                            <img src='/images/watchlist-icon.svg' />
                            <span>WATCHLIST</span>
                        </a>
                        <a href=''>
                            <img src='/images/original-icon.svg' />
                            <span>ORIGINALS</span>
                        </a>
                        <a href=''>
                            <img src='/images/movie-icon.svg' />
                            <span>MOVIES</span>
                        </a>

                        <a href=''>
                            <img src='/images/series-icon.svg' />
                            <span>SERIES</span>
                        </a>

                    </NavMenu>

                    <UserImg onClick={signOut1} src={userPhoto.phone} />

                </>
            }
        </Nav>

    )

}

const Nav = styled.div`
height: 70px;
background: #090b13;
display: flex;
align-items: center;
overflow-x: hidden;
padding: 0 36px;
//margin:0;
`

const Logo = styled.img`
width:80px;
`
const CointainLogin = styled.div`
flex:1;
display: flex;
justify-content: flex-end;
`
const Login = styled.div`
border: 1px solid #f9f9f9;
padding: 8px 16px;
border-radius:4px ;
letter-spacing: 1.5px;
cursor:pointer;
transition: all .2s ease 0s;
text-transform: uppercase;
background-color: rgba(0,0,0,.6);


&:hover{
    background-color: #f9f9f9;
    color: #000;
    border-color: transparent;
}
`
const NavMenu = styled.div`
display: flex; 
flex: 1;
margin-left:25px;
align-items: center;
a{
    display: flex; 
    align-items: center;
    padding: 0 12px;

    img{
        height: 20px;
    }

    span{
        font-size:13px;
        letter-spacing:1.42px;
        position:relative; 
        
        &:after{
            content:" ";
            height: 2px;
            background: white;
            position: absolute;
            left:0;
            right:0;
            bottom:-6px;
            opacity:0;
            transform-orgin: left center;
            transition: all 250ms cubic-bezier(0.25,0.46,0.45,0.94) 0s;
            transform: scaleX(0);
        }

    }
    &:hover{
        span:after{
            opacity:1;
            transform:scaleX(1);
        }
    }
}
`
const UserImg = styled.img`
width: 48px;
height: 48px;
border-radius: 50%;
cursor:pointer;
// justify-content:
`